// extracted by mini-css-extract-plugin
var _1 = "back-dBkgk";
var _2 = "email-PDiM_";
var _3 = "error-rSqCe";
var _4 = "otp-t1Uh4";
var _5 = "receive-9NNPq";
var _6 = "send-Qc7oN";
var _7 = "title-k0p4w";
export { _1 as "back", _2 as "email", _3 as "error", _4 as "otp", _5 as "receive", _6 as "send", _7 as "title" }
